import style from './InputPhone.module.scss';

const PATTERN = /\D/g;

const getInputNumbersValue = value => {
  return value.replace(PATTERN, '');
};

const handlePhoneInput = event => {
  const input = event.target;
  let formattedInputValue = '';
  const selectionStart = input.selectionStart;

  let inputNumbersValue = getInputNumbersValue(input.value);

  if (!inputNumbersValue) {
    input.value = '+7';
    return;
  }

  if (input.value.length !== selectionStart) {
    return;
  }

  const firstSymbol = '+7';
  formattedInputValue = firstSymbol + ' ';

  if (inputNumbersValue[0] === '') {
    inputNumbersValue = ' ';
  }

  if (inputNumbersValue[0] === '0') {
    inputNumbersValue = '';
  }

  if (inputNumbersValue[0] !== '8' && inputNumbersValue[0] !== '7') {
    inputNumbersValue = '7' + inputNumbersValue;
  }

  if (inputNumbersValue.length > 1) {
    formattedInputValue += '(' + inputNumbersValue.slice(1, 4);
  }

  if (inputNumbersValue.length >= 5) {
    formattedInputValue += ') ' + inputNumbersValue.slice(4, 7);
  }

  if (inputNumbersValue.length >= 8) {
    formattedInputValue += '-' + inputNumbersValue.slice(7, 9);
  }

  if (inputNumbersValue.length >= 10) {
    formattedInputValue += '-' + inputNumbersValue.slice(9, 11);
  }

  input.value = formattedInputValue;
};

const handleBackspaceAtStart = (input, event) => {
  if (input.selectionStart <= 2) {
    event.preventDefault();
    return true;
  }
  return false;
};

const handleBackspaceInParentheses = (input, event) => {
  if (input.value.split(')')[0].split('(')[1].length < 3 && input.selectionStart === 3) {
    event.preventDefault();
    return true;
  }
  return false;
};

const handleBackspaceAtSpecialPositions = (input, event) => {
  const specialPositions = [3, 4, 9, 8, 13, 16];
  if (specialPositions.includes(input.selectionStart)) {
    const newPosition = input.selectionStart === 4 ? 2 : input.selectionStart - 1;
    input.setSelectionRange(newPosition, newPosition);
    if (input.selectionStart !== 4) {
      event.preventDefault();
    }
    return true;
  }
  return false;
};

const handlePhoneKeyDown = event => {
  const input = event.target;

  if (event.key === 'Backspace') {
    if (getInputNumbersValue(input.value).length === 1) {
      input.value = '';
      return;
    }

    if (
      handleBackspaceAtStart(input, event) ||
      handleBackspaceInParentheses(input, event) ||
      handleBackspaceAtSpecialPositions(input, event)
    ) {
      return;
    }
  }

  return input;
};

const handlePhonePaste = event => {
  const pasted = event.clipboardData ?? window.clipboardData;
  const input = event.target;
  const inputNumbersValue = getInputNumbersValue(input.value);
  input.value = '';

  if (pasted) {
    const pastedText = pasted.getData('Text');
    if (PATTERN.test(pastedText)) {
      input.value = inputNumbersValue;
    }
  }
};

function InputPhone(props) {
  return (
    <>
      <input
        {...props.register}
        {...props.field}
        type='tel'
        autoComplete='tel'
        className={props.page === 'visual' ? props.inputClassName : style.inputPhone}
        maxLength={18}
        placeholder='Телефон'
        onInput={event => handlePhoneInput(event)}
        onKeyDown={event => {
          handlePhoneKeyDown(event);
        }}
        onPaste={event => {
          handlePhonePaste(event);
        }}
        data-has-error={Boolean(props.errors)}
        id='inputId'
      />
      <label htmlFor='inputId' className={props.page === 'visual' ? props.labelClassName : style.inputLabel}>
        Телефон
      </label>
      <div className={style.inputError}>{props.errors && props.errorLabel}</div>
    </>
  );
}

export default InputPhone;
